<template>
    <DModal
        v-model="activity_log_comment"
        :show="showModal"
        :title="__('customers.contracts.move_contract.move_contract')"
        :is-awaiting-validation="true"
        :show-change-reason-input="true"
        class="overflow"
        close-color-secondary
        :show-incident-list="true"
        :customer-id="contract.customer_id"
        @setIncident="setIncident"
        @update:show="$emit('update:showModal', $event)"
        @confirm="moveContractConfirm"
        @close="$emit('close-modal')"
    >
        <SearchCustomerForm
            @selectCustomer="selectCustomer"
        />
        <DCol class="p-3">
            <div v-if="selectedCustomer">
                <div v-if="selectedCustomer">
                    <span class="fw-bold">{{ __('customers.contracts.move_contract.selected_customer') + ":" }}</span><br>
                    <span>
                        {{ selectedCustomer.firstname }} {{ selectedCustomer.lastname }}<br v-if="selectedCustomer.firstname || selectedCustomer.lastname">
                        {{ selectedCustomer.extended_company }}<br v-if="selectedCustomer.extended_company"><br>
                        {{ selectedCustomer.address1 }}<br>
                        {{ selectedCustomer.address2 }}<br v-if="selectedCustomer.address2">
                        {{ selectedCustomer.postal_code }} {{ selectedCustomer.city }}<br>
                        {{ selectedCustomer.country ? selectedCustomer.country.name : '' }}<br>
                        {{ selectedCustomer.email }}
                    </span>
                </div>
            </div>
            <span
                v-else
                class="fw-bold"
            >{{ __('customers.contracts.move_contract.no_customers_selected') }}</span>
        </DCol>
        <DCol class="p-3">
            <DFormRow
                :label="__('customers.contracts.move_contract.skip_fulfillment')"
            >
                <DSwitch
                    v-model="skipFulfillment"
                    color="success"
                    variant="3d"
                    @update:checked="updateSkipFulfillment"
                />
            </DFormRow>
            <DFormRow
                :label="__('customers.contracts.move_contract.detach_terminated_child_contracts_before_move')"
            >
                <DSwitch
                    v-model="detachTerminatedChildContractsBeforeMove"
                    color="success"
                    variant="3d"
                    @update:checked="updateDetachTerminatedChildContractsBeforeMove"
                />
            </DFormRow>
        </DCol>
        <template #actions>
            <DButton
                :label="__('messages.confirm')"
                :disabled="selectedCustomer === null"
                color="primary"
                @click="moveContractConfirm"
            />
        </template>
    </DModal>
</template>

<script>
import SearchCustomerForm from '~@/Components/Customers/Customers/SearchCustomerForm'

export default {
    name: 'MoveContractModal',
    components: {
        SearchCustomerForm
    },
    props: {
        contract: {
            type: Object,
            default: () => { return {} }
        },
        showModal: {
            type: Boolean,
            default: false
        },
        filters: {
            type: Object,
            default: () => { return {} }
        }
    },
    emits: ['close-modal', 'update:showModal'],
    data () {
        return {
            selectedCustomer: null,
            activity_log_comment: '',
            incident_id: null,
            skipFulfillment: false,
            detachTerminatedChildContractsBeforeMove: false
        }
    },
    methods: {
        selectCustomer (customer) {
            if (typeof customer !== 'undefined') {
                this.selectedCustomer = customer
            }
        },
        moveContractConfirm () {
            if (this.selectedCustomer === null) {
                return
            }

            this.$inertia.post(this.$route('customers.customers.contracts.move', {
                customer: this.contract.customer_id,
                contract: this.contract.id,
                newCustomer: this.selectedCustomer,
                activity_log_comment: this.activity_log_comment,
                filters: this.filters,
                incident_id: this.incident_id,
                skip_fulfillment: this.skipFulfillment,
                detach_terminated_child_contracts_before_move: this.detachTerminatedChildContractsBeforeMove
            }),
            {},
            {
                onSuccess: () => {
                    this.$emit('close-modal')
                }
            })
        },
        setIncident (value) {
            this.incident_id = value
        },
        updateSkipFulfillment (value) {
            this.skipFulfillment = value
        },
        updateDetachTerminatedChildContractsBeforeMove (value) {
            this.detachTerminatedChildContractsBeforeMove = value
        },
    }
}
</script>

<style scoped>
    .overflow {
        overflow-y: auto !important;
    }
</style>
